<template>
  <div v-bind="$attrs">
    <v-menu v-if="item.allowCancellation" location="bottom">
      <template v-slot:activator="{ props }">
        <MenuActivator v-bind="props" data-cy="subscriptionMenuDropdown" />
      </template>
      <v-list>
        <v-tooltip location="left" :disabled="!isLogInAs">
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-list-item
                :disabled="isLogInAs"
                @click.stop="$emit('cancelSubscriptionOpen', item.activationId)"
                link
                data-cy="cancelSubscriptionActivator"
              >
                <template v-slot:prepend>
                  <v-icon :icon="'mdi-close'" />
                </template>
                <v-list-item-title>
                  {{ $t('manageSubscriptions.menu.cancelSubscription') }}
                </v-list-item-title>
              </v-list-item>
            </div>
          </template>
          <span>{{ $t('manageSubscriptions.unavailableForLogInAs') }}</span>
        </v-tooltip>
        <v-tooltip location="left" :disabled="!isLogInAs">
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-list-item
                :disabled="isLogInAs"
                @click.stop="
                  $emit('subscriptionBillingInfoOpen', item.activationId, item.subscriptionId)
                "
                link
                data-cy="subscriptionBillingInfoActivator"
              >
                <template v-slot:prepend>
                  <v-icon :icon="'mdi-credit-card'" />
                </template>
                <v-list-item-title>
                  {{ $t('manageSubscriptions.menu.updateBilling') }}
                </v-list-item-title>
              </v-list-item>
            </div>
          </template>
          <span>{{ $t('manageSubscriptions.unavailableForLogInAs') }}</span>
        </v-tooltip>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import MenuActivator from '@/components/common/buttons/MenuActivator.vue'

interface ActionMenuItem {
  activationId: string
  subscriptionId: string
  allowCancellation: boolean
}

export default defineComponent({
  name: 'ActionMenu',
  inheritAttrs: false,
  components: {
    MenuActivator
  },
  emits: ['cancelSubscriptionOpen', 'subscriptionBillingInfoOpen'],
  props: {
    item: {
      type: Object as PropType<ActionMenuItem>,
      required: true
    },
    isLogInAs: {
      type: Boolean,
      required: true
    }
  }
})
</script>
